export default __webpack_public_path__ + "static/media/book15.57337f82.svg";